import React , { useState } from 'react'
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import AccountCircleIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from "react-router-dom";
import { useStore } from './store/comercioStore' ;
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Snackbar from '@mui/material/Snackbar';

function Recuperacion() {
  const [ cuit,setCuit] = useState('');
  const [ email,setEmail] = useState('');
  const { comercioId , asigna , tipo ,asignaTipo ,asignaNom , asignaSocio}  = useStore();
  const [ msgInfo,setMsgInfo] = useState(false); 
  const [ msgError,setMsgError] = useState(false); 
  const [ msj, setMsj] = useState("");
  const navigate = useNavigate()
  const theme = createTheme();

  const handleSubmit = async (event) => {
    event.preventDefault();
    const postData = {
      cuit : cuit
    };
    try {
      const baseURL = process.env.REACT_APP_SERVER_PATH + 'recuperacion';
      const res = await fetch(`${baseURL}`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": "token-value",
          'Access-Control-Allow-Origin': '*'
        },
        body: JSON.stringify(postData),
      });
         console.log(res.status)
      if (res.status === 200 || res.status === 401) {
          const data = await (res.json());
          setMsj(data);
         setMsgInfo(true);
          console.log(data);
                    //navigate('/')
          } 
      else
            {  
                if (res.status === 402 || res.status === 404) {
                    setMsgError(true);
                  }
              }
       
          } catch (err) {
          }
  };
  
  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
           <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <AccountCircleIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Recuperación de Credenciales
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              name="cuit"
              label="CUIT"
              inputMode="numeric" pattern="[0-9]*"
              id="cuit"
              autoComplete="current-password"
              value={cuit}
              onChange = {(e) => setCuit(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Envio
            </Button>
          </Box>
        </Box>
      </Container>
      <Snackbar open = {msgInfo}  onClose={ ()=> setMsgInfo(false)}>
                <Alert severity="info" variant='filled'>
                  <AlertTitle>Correo</AlertTitle>
                    {msj}</Alert>
      </Snackbar>
      <Snackbar open = {msgError} autoHideDuration={6000} onClose={ ()=> setMsgError(false)}>
                <Alert severity="error" variant='filled'>
                  <AlertTitle>Error de credenciales</AlertTitle>
                    No existe el CUIT</Alert>
      </Snackbar>
    </ThemeProvider>
  )
}

export default Recuperacion